import { render, staticRenderFns } from "./BookingDocumentsButton.vue?vue&type=template&id=0505741e&scoped=true"
import script from "./BookingDocumentsButton.vue?vue&type=script&lang=js"
export * from "./BookingDocumentsButton.vue?vue&type=script&lang=js"
import style0 from "./BookingDocumentsButton.vue?vue&type=style&index=0&id=0505741e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0505741e",
  null
  
)

export default component.exports